module.exports = __webpack_public_path__ + "img/LOGO-5.a3797eb8.png";